import type { VaultProfile } from '@ducat-unit/core';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export function vaultSelectionScope(validatorUrl?: string, network?: string, pubkey?: string) {
  return validatorUrl && network && pubkey ? JSON.stringify([validatorUrl, network, pubkey]) : undefined;
}

export function selectActiveVault(vaults: VaultProfile[] | undefined, root?: string) {
  return vaults?.find((vault) => vault.coin_id != null && vault.root_txid === root) ?? vaults?.find((vault) => vault.coin_id != null);
}

type VaultSelectionState = {
  roots: Record<string, string>;
  select: (scope: string, root: string) => void;
};

export const useVaultSelectionStore = create<VaultSelectionState>()(
  persist(
    (set) => ({
      roots: {},
      select: (scope, root) => set((state) => ({ roots: { ...state.roots, [scope]: root } })),
    }),
    { name: 'vault-selection', partialize: (state) => ({ roots: state.roots }) },
  ),
);
